import { render, staticRenderFns } from "./CategoryDropdown.vue?vue&type=template&id=51f98d6e&scoped=true"
import script from "./CategoryDropdown.vue?vue&type=script&lang=js"
export * from "./CategoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./CategoryDropdown.vue?vue&type=style&index=0&id=51f98d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f98d6e",
  null
  
)

export default component.exports